// Authentication utility functions
export const shouldRequireAuth = (): boolean => {
  return import.meta.env.VITE_REQUIRE_AUTH === 'true'
}

/**
 * 登入後的角色落地頁：
 * 學生沒有儀表板（/dashboard 是教學管理視角），直接進課程列表
 */
export const getHomeRouteForRole = (role?: string): string => {
  switch (role) {
    case 'admin':
      return '/admin/dashboard'
    case 'teacher':
      return '/dashboard'
    default:
      return '/courses'
  }
}

export const isAuthRequired = (): boolean => {
  return shouldRequireAuth()
}

export const isDevelopmentMode = (): boolean => {
  // 檢查多種開發模式指標
  return import.meta.env.VITE_ENVIRONMENT === 'development' || 
         import.meta.env.DEV === true ||
         import.meta.env.MODE === 'development' ||
         window.location.hostname === 'localhost' ||
         window.location.hostname === '127.0.0.1'
}

export const hasValidToken = (): boolean => {
  if (typeof window === 'undefined') return false
  
  const token = localStorage.getItem('access_token')
  return !!token
}

export const isAuthenticated = (): boolean => {
  // If auth is not required (development mode), always return true
  if (!shouldRequireAuth()) {
    return true
  }
  
  // If auth is required, check for valid token
  return hasValidToken()
}

export const getAuthStatus = () => {
  return {
    authRequired: shouldRequireAuth(),
    isDev: isDevelopmentMode(),
    hasToken: hasValidToken(),
    isAuthenticated: isAuthenticated()
  }
}